var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { PrismicService, Prismic } from '../prismic/prismic.service';
import { SliceService } from '../slice/slice.service';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
var ProjectService = /** @class */ (function () {
    function ProjectService(prismicService, httpClient, sliceService) {
        this.prismicService = prismicService;
        this.httpClient = httpClient;
        this.sliceService = sliceService;
        this.fetchOnePromiseMap = new Map();
        this.fetchGeoJsonPromiseMap = new Map();
    }
    ProjectService.prototype.getOne = function (uid) {
        var promise = this.fetchOnePromiseMap.get(uid);
        if (promise)
            return promise;
        promise = this.fetchOne(uid);
        this.fetchOnePromiseMap.set(uid, promise);
        return promise;
    };
    ProjectService.prototype.getAll = function () {
        return this.fetchAllPromise || (this.fetchAllPromise = this.fetchAll());
    };
    ProjectService.prototype.getGeoJson = function (url) {
        var promise = this.fetchGeoJsonPromiseMap.get(url);
        if (promise)
            return promise;
        promise = this.fetchGeoJson(url);
        this.fetchGeoJsonPromiseMap.set(url, promise);
        return promise;
    };
    ProjectService.prototype.fetchAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            var api, projectResponse;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prismicService.api()];
                    case 1:
                        api = _a.sent();
                        return [4 /*yield*/, api.query([
                                Prismic.Predicates.at('document.type', 'project')
                            ], null, null)];
                    case 2:
                        projectResponse = _a.sent();
                        return [2 /*return*/, projectResponse.results.map(function (r) { return _this.convertResultToProject(r); })];
                }
            });
        });
    };
    ProjectService.prototype.fetchOne = function (uid) {
        return __awaiter(this, void 0, void 0, function () {
            var api, projectResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.prismicService.api()];
                    case 1:
                        api = _a.sent();
                        return [4 /*yield*/, api.query([
                                Prismic.Predicates.at('document.type', 'project'),
                                Prismic.Predicates.at('my.project.uid', uid)
                            ], null, null)];
                    case 2:
                        projectResponse = _a.sent();
                        return [2 /*return*/, this.convertResultToProject(projectResponse.results[0])];
                }
            });
        });
    };
    ProjectService.prototype.convertResultToProject = function (result) {
        var data = result.data;
        return {
            id: result.id,
            uid: result.uid,
            name: data.name,
            status: data.status || 'finished',
            locationUrl: data.location.url,
            mapTagSide: data.map_tag_side || 'right',
            body: this.sliceService.parseBody(data.body),
            mediaLinks: !data.media_links ? [] : data.media_links.map(function (mediaLinkData) {
                var date = new Date(mediaLinkData.date);
                var mediaLink = {
                    title: mediaLinkData.title,
                    url: mediaLinkData.url.url,
                    source: mediaLinkData.source,
                    date: date
                };
                return mediaLink;
            }).sort(function (a, b) { return a.date > b.date ? -1 : 1; }),
            gallery: (data.gallery || []).map(function (imageData) {
                var galleryItem = {
                    mainUrl: imageData.image.url,
                    mediumUrl: imageData.image.medium.url
                };
                return galleryItem;
            })
        };
    };
    ProjectService.prototype.fetchGeoJson = function (url) {
        return this.httpClient.get(url).pipe(take(1)).toPromise();
    };
    return ProjectService;
}());
export { ProjectService };
//# sourceMappingURL=project.service.js.map